import {
  KNOWLEDGE_DOC_FULLSCREEN_TOGGLE,
  useGeckoAnalytics,
} from 'features/analytics'
import { useKnowledgeDocumentUXContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'
import { useCallback } from 'react'

export function useDocumentFullscreen() {
  const { isDocumentFullscreen, setIsDocumentFullscreen } =
    useKnowledgeDocumentUXContext()
  const { trackEvent } = useGeckoAnalytics()

  const enterDocumentFullscreen = useCallback(() => {
    if (isDocumentFullscreen) return
    trackEvent(KNOWLEDGE_DOC_FULLSCREEN_TOGGLE.title, { action: 'enter' })
    setIsDocumentFullscreen(true)
  }, [isDocumentFullscreen, setIsDocumentFullscreen, trackEvent])

  const exitDocumentFullscreen = useCallback(() => {
    if (!isDocumentFullscreen) return
    trackEvent(KNOWLEDGE_DOC_FULLSCREEN_TOGGLE.title, { action: 'exit' })
    setIsDocumentFullscreen(false)
  }, [isDocumentFullscreen, setIsDocumentFullscreen, trackEvent])

  return { enterDocumentFullscreen, exitDocumentFullscreen }
}
